import React, { useState, ChangeEvent } from 'react';
import { styled } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField';
import { MuiTelInput } from 'mui-tel-input'

class PhoneChangeEvent implements ChangeEvent<HTMLInputElement> {
  target: HTMLInputElement;
  nativeEvent: Event;
  currentTarget: HTMLInputElement;
  bubbles: boolean = false;
  cancelable: boolean = true;
  defaultPrevented: boolean = false;
  eventPhase: number = 0;
  isTrusted: boolean = true;

  constructor(target: HTMLInputElement) {
    this.target = target;
    this.nativeEvent = new Event('change');
    this.currentTarget = this.target;
  }

  preventDefault(): void {
    this.defaultPrevented = true;
  }
  isDefaultPrevented(): boolean {
    return this.defaultPrevented;
  }
  stopPropagation(): void {
    this.bubbles = false;
  }
  isPropagationStopped(): boolean {
    return !this.bubbles;
  }
  persist(): void {}
  timeStamp: number;
  type: string;
}

const MuiTelInputStyled = styled(MuiTelInput)`
  .MuiTelInput-Flag img {
    width: 14px;
    height: 12px;
  }
`;

export default function ({ value, onChange, ...props }: TextFieldProps) {
  const inputRef = React.createRef<HTMLInputElement>();
  const [val, setValue] = useState<string>(value as string);
  return (
    <MuiTelInputStyled
      inputRef={inputRef}
      value={val}
      onChange={(v, i) => {
        if (typeof onChange == 'function') {
          if (inputRef.current) {
            const value = inputRef.current.value;
            inputRef.current.value = v.replace(/\s+/g, '');
            onChange(new PhoneChangeEvent(inputRef.current));
            inputRef.current.value = value;
          }
        }
        setValue(v);
      }}
      {...props}
      defaultCountry="RU"
      disableDropdown={true}
    />
  );
}
